export default {
  org: {
    Type: '类型',
    Parent: '上级',
    ParentName: '上级名称',
    SearchByName: '名称查询',
    ChooseParent: '选择上级',
    EditParent: '修改上级'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/org.js